export class PrinterJobItem {
	pk: string; //PRINTER_JOB_:serialNumber
	sk: string; //:JOBID (Unix)
	created: string;
	received: string;
	printed: string;
	completed: string;
	payload: any;
	status: number;
	checkKey: string;
	posPrintJob: string;
	kitchenPrintJob: any;
	posPrintJobFileName: string;
	printOrderSessionKey: string;

	public constructor(init?: Partial<PrinterJobItem>) {
		Object.assign(this, init);
	}
}
